module.exports = __webpack_public_path__ + "img/Wealth-Bucketing_Intro.ff4eabab.png";